import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  LayoutDashboard, Users, Package, Truck, Car, FileText,
  Gavel, MapPin, Wrench, DollarSign, Receipt, FolderOpen,
  LogOut, Settings, ChevronRight, Building2, ShieldCheck, Smartphone, MessageCircle, Flame, ClipboardList
} from 'lucide-react';

const navItems = [
  { section: 'Principal' },
  { path: '/', icon: <LayoutDashboard size={16} />, label: 'Dashboard' },
  { section: 'Operação' },
  { path: '/assets', icon: <Package size={16} />, label: 'Banheiros' },
  { path: '/drivers', icon: <Users size={16} />, label: 'Motoristas' },
  { path: '/vehicles', icon: <Car size={16} />, label: 'Veículos' },
  { path: '/logistics', icon: <MapPin size={16} />, label: 'Logística' },
  { path: '/maintenance', icon: <Wrench size={16} />, label: 'Manutenção' },
  { section: 'Comercial' },
  { path: '/clients', icon: <Building2 size={16} />, label: 'Clientes' },
  { path: '/contracts', icon: <FileText size={16} />, label: 'Contratos' },
  { path: '/tenders', icon: <Gavel size={16} />, label: 'Licitações' },
  { section: 'Financeiro' },
  { path: '/financial', icon: <DollarSign size={16} />, label: 'Financeiro' },
  { path: '/invoices', icon: <Receipt size={16} />, label: 'Notas Fiscais' },
  { section: 'Gestão' },
  { path: '/motorista', icon: <Smartphone size={16} />, label: 'App Motorista', driverApp: true },
  { path: '/heatmap', icon: <Flame size={16} />, label: 'Mapa de Calor' },
  { path: '/audit', icon: <ClipboardList size={16} />, label: 'Auditoria', adminOnly: true },
  { path: '/communications', icon: <MessageCircle size={16} />, label: 'Comunicações' },
  { path: '/superadmin', icon: <ShieldCheck size={16} />, label: 'Superadmin', superadminOnly: true },
  { path: '/documents', icon: <FolderOpen size={16} />, label: 'Documentos' },
  { path: '/users', icon: <Users size={16} />, label: 'Usuários', adminOnly: true },
  { path: '/settings', icon: <Settings size={16} />, label: 'Configurações' },
];

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <div className="sidebar-logo-icon">🚽</div>
        <div>
          <div className="sidebar-logo-text">SaniTech</div>
          <div className="sidebar-logo-sub">Gestão de Banheiros</div>
        </div>
      </div>

      <nav className="sidebar-nav">
        {navItems.map((item, i) => {
          if (item.section) return (
            <div key={i} className="sidebar-section">{item.section}</div>
          );
          if (item.adminOnly && user?.role !== 'admin' && user?.role !== 'superadmin') return null;
          if (item.superadminOnly && user?.role !== 'superadmin') return null;
          if (item.driverApp) return null; // accessible via /motorista directly
          const active = location.pathname === item.path ||
            (item.path !== '/' && location.pathname.startsWith(item.path));
          return (
            <div
              key={item.path}
              className={`nav-item ${active ? 'active' : ''}`}
              onClick={() => navigate(item.path)}
            >
              {item.icon}
              <span>{item.label}</span>
              {active && <ChevronRight size={14} style={{ marginLeft: 'auto', opacity: 0.7 }} />}
            </div>
          );
        })}
      </nav>

      <div style={{ padding: '12px 8px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
        <div style={{ padding: '8px 12px', borderRadius: 6, background: 'rgba(255,255,255,0.05)', marginBottom: 4 }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: 'white' }}>{user?.name}</div>
          <div style={{ fontSize: 11, color: 'var(--gray-400)', textTransform: 'capitalize' }}>{user?.role}</div>
        </div>
        <div
          className="nav-item"
          onClick={() => { logout(); navigate('/login'); }}
          style={{ color: '#ef4444' }}
        >
          <LogOut size={16} />
          <span>Sair</span>
        </div>
      </div>
    </aside>
  );
}
